<div class="container">
  <ion-row>
    <ion-col size="2" class="mt-10">
      <!-- <div class="formLabelRegularfs16 mb-5">
        Year
      </div> -->
      <mat-form-field class="w-100 mat-height40 mat-input-style">
        <mat-select placeholder="Select" [(ngModel)]="selectedYear" (selectionChange)="viewReimbursementReportByYear($event.value)">
          <mat-option [value]="item.year" *ngFor="let item of pmsYears">
            {{sharedService.transformYearToFyFormat(item.year)}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ion-col>

      <ion-col size="2" class="mt-10">
        <!-- <div class="formLabelRegularfs16  mb-5">
          Select Dept
        </div> -->
  
        <ng-multiselect-dropdown  [placeholder]="'Select Employee'" [settings]="dropdownSettings"
        [data]="getEmpList" *ngIf="getEmpList.length > 0" [(ngModel)]="selectedEmployee" (onSelect)="onSelectEmployee()"
        (onDeSelect)="onDeSelectEmployee()" (onSelectAll)="selectAllEmployee($event)"
        (onDeSelectAll)="onDeSelectAllEmployee()">
      </ng-multiselect-dropdown>
      </ion-col>
      <!-- <ion-col size="3" class="mt-10" >
    
 
        <mat-form-field class="w-100 mat-height40 mat-input-style">
          <mat-select placeholder="Select" [(ngModel)]="selectEmployee" >
            <mat-option [value]="-1">Select Employee</mat-option>
            <mat-option>
         1
            </mat-option>
          </mat-select>
        </mat-form-field>
      </ion-col> -->

  </ion-row>
  <div class="cardBox mb-20 mt-10">


    <ion-row>
      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3" class="ml-20 mt-20">
        <mat-form-field class="mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">

        </mat-form-field>
      </ion-col>
      <ion-col class="mt-20">
        <label>
          <ion-label class="fs-14 font_regular pr-10 black_color ml-10 ">Show</ion-label>
          <mat-form-field class="w70px mat-height40 mat-input-style">
            <mat-select placeholder="Select" placeholder="Select"(selectionChange)="DislaySelectedRecord($event)" [value]="25">
              <mat-option [value]="2">2</mat-option>
              <mat-option [value]="25">25</mat-option>
              <mat-option [value]="50">50</mat-option>
              <mat-option [value]="75">75</mat-option>
              <mat-option [value]="100">100</mat-option>
            </mat-select>
          </mat-form-field>
          <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
        </label>
      </ion-col>


      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <div class="d-flex justify-content-flex-end ">
          <div class="d-flex" style="margin-right: 15px; margin-top: 10px;">
            <span class="ml-5 mr-5 icon-download fs-20 material-icons" (click)="downloadEmployeeList()">download</span>
          </div>
        </div>
      </ion-col>
    </ion-row>
    <div class="p-10">
      <ion-row>
        <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
          <div class="table-container">
            <table>
              <thead>
                <tr>

                  <th *ngFor="let item of OfferAndAppointmentTableHeader" class="fs-14 font_bold cl-black">
                    <div class="p-5 verticle-center justify-content-space-between icon-style"style="width: 100px !important;">
                      {{ item?.label }}
                     
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let employee of employees; let i = index">
                
                  <td>{{ employee.salutation  }}</td>
                  <td >{{ employee.firstName }}</td>
                  <td>{{ employee.lastName }}</td>
                  <td>{{ employee.email  }}</td>
                  <td>{{ employee.gender  }}</td>
                  <!-- <td>{{ employee.address }}</td> -->
                  <!-- <td>{{employee.permanentAddress}}</td> -->
                  <td>
                    <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="employee.address" 
                      maxlength="255" readonly></textarea>
                  </td>
                  <td>
                    <textarea rows="2" cols="4" class="edittextarea" [(ngModel)]="employee.permanentAddress" 
                      maxlength="255" readonly></textarea>
                  </td>
                  <td>{{employee.country}}</td>
                  <td>{{employee.maritalStatus}}</td>
                  <td >{{employee.dateOfBirth | date: 'dd-MM-yyyy'}}</td>  
                   <td>{{employee.age}}</td>
                   <td>{{employee.aadharNo}}</td>
                   <td>{{employee.panNo}}</td>
                   <td>{{employee.uan}}</td>
                   <td>{{employee.contactNo  }}</td>
                   <td>{{employee.totalExperience}}</td>
                   <td>{{employee.emergencyContactNo}}</td>
                   <td>{{employee.bloodGroup}}</td>
                   <td>{{employee.fathersName}}</td>
                   <td>{{employee.mothersName}}</td>
                   <td>{{employee.spouseName}}</td>
                   <td>{{employee.noOfChildren}}</td>
                   <td>{{employee.isRelativeWorking ?'Yes':'No'}}</td>
                   <td>{{employee.highestEducationQualification}}</td>
                   <td>{{employee.highestEducationInstitute}}</td>
                   <td>{{employee.highestEducationYearOfPassing}}</td>
                   <td>{{employee.highestEducationMarks}}</td>


                   <td>{{employee.highestEducationQualification2}}</td>
                   <td>{{employee.highestEducationInstitute2}}</td>
                   <td>{{employee.highestEducationYearOfPassing2}}</td>
                   <td>{{employee.highestEducationMarks2}}</td>

                   <td>{{employee.highestEducationQualification3}}</td>
                   <td>{{employee.highestEducationInstitute3}}</td>
                   <td>{{employee.highestEducationYearOfPassing3}}</td>
                   <td>{{employee.highestEducationMarks3}}</td>

                   <td>{{employee.highestProfessionalQualification}}</td>
                   <td>{{employee.highestProfessionalInstitute}}</td>
                   <td>{{employee.highestProfessionalYearOfPassing}}</td>
                   <td>{{employee.highestProfessionalMarks}}</td>

                   <td>{{employee.lastOrganisationName}}</td>
                   <td>{{employee.lastOrganisationDoj}}</td>
                   <td>{{employee.lastOrganisationLwd}}</td>
                   <td>{{employee.lastOrganisationEmployee}}</td>
                   <td>{{employee.lastOrganisationDesignation}}</td>

                   <td>{{employee.lastToLastOrganisationName}}</td>
                   <td>{{employee.lastToLastOrganisationDoj}}</td>
                   <td>{{employee.lastToLastOrganisationLwd}}</td>
                   <td>{{employee.lastToLastOrganisationEmployee}}</td>
                   <td>{{employee.lastToLastOrganisationDesignation}}</td>

                   <td>{{employee.otherOrganisationName}}</td>
                   <td>{{employee.otherOrganisationDoj}}</td>
                   <td>{{employee.otherOrganisationLwd}}</td>
                   <td>{{employee.otherOrganisationEmployee}}</td>
                   <td>{{employee.otherOrganisationDesignation}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ion-col>
      </ion-row>
    </div>
  </div>
</div>